module.exports = __webpack_public_path__ + "img/chuizi.50ede7ff.png";